module.exports = __webpack_public_path__ + "img/The_US_Treasuries_Clearing_Challenge.f8982c4d.jpg";